import React from "react";
import { bgMembershipBanner } from "assets";
import Tiers from "./Tiers";
import { BackgroundSection } from "../LandingPage/common";
import EmailSignUp from "../LandingPage/common/EmailSignUp";
import { useMediaQuery } from "@material-ui/core";

const Header = () => {
  let maxHeight = "760px"
  let marginTop = "220px"
  const isMediumScreen = useMediaQuery('(min-width: 1024px) and (max-width: 1110px)') // 510px
  const isLargeScreen = useMediaQuery('(min-width: 1112px) and (max-width: 1300px)') // 568px
  const isXLargeScreen = useMediaQuery('(min-width: 1302px) and (max-width: 1582px)') // 640px
  if (isMediumScreen) {
    maxHeight = "510px"
    marginTop = "110px"
  }
  if (isLargeScreen) {
    maxHeight = "568px"
    marginTop = "160px"
  }
  if (isXLargeScreen) {
    maxHeight = "640px"
    marginTop = "190px"
  }
  return (
    <>
      <BackgroundSection
        backgroundImage={`url(${bgMembershipBanner.default})`}
        maxHeight={maxHeight}
        backgroundPosition="45%"
        className="relative h-screen bg-no-repeat bg-cover pt-20 px-4 mb-1 flex flex-col justify-end"
      >
        <div className="flex flex-col text-center text-white relative m-auto" style={{ marginTop: marginTop }}>
          <h1 className="text-2xl md:text-6xl font-semibold" style={{
            color: "#fff",
            fontWeight: 700,
            textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000, 0 4px 10px rgba(0, 0, 0, 0.35)"
          }}>Membership</h1>
          {/* <p className="text-lg text-wrap sm:w-3/4 self-center">
            Choose your perfect fit! We offer three membership tiers (FREE, PREMIUM, ALL ACCESS) to
            suit your eligibility and budget, available as monthly or annual subscriptions.
          </p> */}
        </div>
      </BackgroundSection>
      <div className="lg:w-9/12 xl:w-7/12 px-4 sm:mx-auto mt-3">
        <div className="space-y-4 text-center">
          <p className="text-2lg py-5">
            Our <strong>Gig Life Pro Members Community</strong> is a <strong>Curated Network Of Over 2000 Global Members</strong>, across <strong>60 Cities Globally</strong>, representing over <strong>50 Roles In The Industry</strong> and with an <strong>Average Of 12+ Yrs Of Experience.</strong>
          </p>

        </div>
      </div>
    </>
  );
};

const Membership = () => {
  return (
    <div className="w-screen flex flex-col">
      <Header />
      <Tiers />
      {/* <EmailSignUp /> */}
    </div>
  );
};

export default Membership;
